import { httpClient } from '../http/httpClient'

export interface ConsultStats {
  j17: boolean
  qitech: boolean
  qitech180: boolean
  schedule: number
  hasAmount: number
  unauthorized: number
}

export async function getStatsConsult() {
  const { data } = await httpClient.get<ConsultStats>('/consults/stats')
  return data
}
